// Top‑level requires (side‑effects only)
require('../../lib/select2/select2-3.4.5/select2.min.js');
require('../jhire/services/jv.Cand.js');
require('../../../assets/scripts/jhire/modules/jv.webpack.js');
// require('../jhire/services/jv.services.js');
require('../common/jv.currentUser.service.js');
require('./jv.candidate.details.app.dummy.js');
require('../jhire/other/jv.CandDetails.findDefaultTemplate.js');
require('./details/jv.candidates.contact.factory.js');
require('./details/jv.candidates.viewfields.factory.js');
require('./details/jv.Candidate.Messages.Factory.js');
require('../jhire/controllers/candidates/jv.Cand.Details.Urls.Fac.js');
require('../jhire/controllers/candidates/jv.Cand.Details.Util.Fac.js');
require('../jhire/controllers/candidates/jv.Cand.Details.Resume.js');
require('../jhire/services/jv.Cand.Details.Evaluations.js');
require('../jhire/controllers/candidates/jv.Cand.Details.Evaluations.js');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.js');
require('../jhire/controllers/candidates/jv.Cand.Details.Messages.js');
require('./details/jv.Candidate.Applications.Controller.js');
require('../jhire/controllers/candidates/jv.Cand.QuickForm.Controller.js');
require('./details/jv.Candidate.Notes.Factory.js');
require('./jv.onboarding.controller.js');
require('../jhire/services/jv.Cand.Resume.Model.js');
require('../jhire/services/jv.apply-form-preview.service.js');
require('../jhire/controllers/candidates/jv.Cand.Details.Summary.js');
require('../common/directives/jv.Common.Constants.Dates.js');
require('./details/jv.Candidate.Profile.Factory.js');
require('./details/jv.Candidate.ProfileHistory.Controller.js');
require('./details/jv.Candidate.Feed.Controller.js');
require('../jhire/controllers/candidates/jv.Cand.Details.ProcessForm.Fac.js');
require('../jhire/controllers/candidates/jv.Cand.Details.Activity.js');
require('../jhire/controllers/candidates/jv.Cand.Details.Paginated');
require('./jv.shareApplication.controller.js');

require('../../lib/js/angularmodule/JV.Core.Directives.js');
require('../../lib/angularJS/angular-animate.js');
require('../../lib/ngStorage/ngStorage.min.js');

require('../common/jv.Position');
require('../jhire/controllers/candidates/jv.Esig.CertificateViewer.app');
require('../jhire/controllers/candidates/jv.Cand.Details.Tasks.js');
require('../videos/recruiter/jv.Cand.Details.SendVideoModal');
require('../videos/recruiter/jv.Cand.Details.sendReminder');
require('../videos/recruiter/jv.Cand.Details.EvalReqMoreInfo');
require('../videos/recruiter/jv.Cand.Details.evalSendReminder');
require('../videos/recruiter/jv.Cand.Details.InviteReviewersModal');
require('./search/jv.candidates.search.controller');
require('../../stylekit/js/jv.SortList.js');
require('../../stylekit/js/jv.Tooltip.js');
require('../../stylekit/js/jv.Calendar');
require('../common/jv.BrowserDetails.js');
require('../common/directives/jv.Datepicker');
require('../common/directives/jv.Select2');
require('../common/jv.MeetingRoomSelect');
require('../common/jv.Jobvite.Urls');
require('../common/directives/jv.Tinymce.webpack.js');
require('../common/jv.EmployeeSelect.js');
require('../common/directives/jv.Reset');
require('../source/contacts/jv.applicantGrid.controller');
require('./details/jv.addToReq.controller');
require('./jv.deleteCandidate.controller');
require('./jv.moveAcrossWorkflow.controller');
require('./jv.addToCollection.controller');
require('./jv.sendMessage.controller');
require('./jv.bulkSelfSchedule.controller');
require('./jv.sendSMSMessage.controller');
require('./jv.submitToHM.controller');
require('./jv.offerReject.controller');
require('./details/jv.moveCandidate.controller');
require('./jv.changeStatus.controller');
require('./jv.sendNote.controller');
require('./jv.rejectCandidate.controller');
require('./jv.bulkResumeDownload.controller');
require('../common/jv.TemplateLoader');
require('../common/jv.Modal');
require('./jv.application.chevron.directive');
require('../common/directives/jv.Common.keyboardEvents.directive');
require('./jv.candidate.modal.controller.js');
require('./search/jv.search.save-modal.directive.js');
require('./search/jv.search.save-list-modal.directive.js');
require('../common/directives/jv.Common.Directives.inputDropDown');
require('../common/directives/jv.FormTemplate.webpack.js');
require('../common/directives/jv.MessageTemplate');
require('../common/jv.MessageBar');
require('../common/jv.Loading');
require('../common/directives/jv.AjaxSelect.js');
require('../source/person/JV.QuickViewCtrl.webpack.js');
require('../videos/recruiter/jv.Cand.List.QuickViewVideo.js');
require('../common/directives/jv.fallbackImage.js');
require('./jv.candidate.action.validation.directive');
require('../videos/recruiter/jv.Videos.Svc.js');
require('../videos/recruiter/jv.Cand.Details.Video.js');
require('../common/jv.Filters.webpack');
require('../common/directives/jv.ActionsDropdown');
require('../common/directives/jv.Dropdown.js');



require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.Sch');
require('../jhire/controllers/candidates/jv.Cand.Details.WorkflowMessager');
require('../jhire/controllers/candidates/jv.Cand.Details.Tasks');
require('../jhire/services/jv.Cand.Details.Evaluations');
require('./details/jv.Candidate.Tasks.Factory');
require('./details/jv.Candidate.ManageCollabTeam.Controller');
require('../jhire/controllers/candidates/jv.Cand.Details.Filters');
require('../jhire/controllers/candidates/jv.Cand.Details.Intelligent.Messaging');
require('../jhire/controllers/candidates/jv.Cand.Details.CRM');
require('../jhire/controllers/candidates/jv.Cand.Details.Resume');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.Scheduler');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.Scheduler.Messager');
require('../jhire/controllers/candidates/jv.Cand.Details.Evaluations.View');
require('../jhire/controllers/candidates/jv.Cand.Details.Evaluations.Submit');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.PreInterviewForm');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.Reject');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.OfferLetter');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.OfferLetter.Generator');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.OfferLetter.Send');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.OfferLetter.Upload');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.EsigOfferLetter');
require('../jhire/controllers/candidates/jv.Cand.Details.Notes');
require('../jhire/controllers/candidates/jv.Cand.Details.Rank.Directive');
require('../jhire/controllers/candidates/jv.Cand.Details.TalentFit.Directive');
require('../common/directives/jv.Dropdown');
require('../common/directives/jv.Select2ModalDropdown');
require('../common/directives/jv.auditlog.directive');
require('../common/directives/jv.pagination.directive');
require('../common/jv.responsive');
require('../common/jv.DocuSignAuth.Svc');
require('../common/directives/consentData/jv.Common.DataConsent.directive');
require('../common/directives/jv.Common.Constants.Dates');
require('../common/directives/jv.Common.Directives.DraggableTabs');
require('../common/jv.NumberFormat.mask.directive');
require('../common/directives/jv.Common.Currency.Directive');
require('../common/directives/jv.HideOnBlur');
require('../common/directives/jv.common.currency.applyfield.directive');
require('../admin/directives/jv.Admin.CustomFormField.directive');

angular.module('jv.candidates.search.app', [
    'jv',
    // 'jv.services',
    'JV.Core.Directives',
    'jv.directives',
    'ngAnimate',
    'ngSanitize',
    'App.video.service',
    'jv.CandDetails.Video',
    'jv.Common.AjaxSelect',
    'jv.quickView',
    'jv.Common.Filters',
    'jv.candidates.service',
    'jv.candidate.details.app',
    'jv.Common.Directives.Actions',
    'jv.Common.Directives.Dropdown',
    'jv.CandDetails.findDefaultTemplate',
    'jv.candidates.contact.factory',
    'jv.candidates.viewfields.factory',
    'jv.Common.Constants.Dates',
    'jv.Candidate.Profile.Factory',
    'jv.Candidate.Feed.Controller',
    'jv.Candidate.ProfileHistory.controller',
    'jv.candidate.details.activity.controller',
    'jv.cand.resume.model.factory',
    'jv.Candidate.Messages.Factory',
    'jv.candidate.details.resume.controller',
    'jv.candidate.details.evaluations.controller',
    'jv.candidate.details.workflow.base.controller',
    'jv.candidate.details.notes.controller',
    'jv.candidate.details.messages.controller',
    'jv.Candidate.Applications.Controller',
    'jv.candidate.details.task.controller',
    'jv.Common.browser.details',
    'jv.candidate.details.urls.factory',
    'jv.candidate.details.util.factory',
    'jv.candidate.details.processform.fac',
    'jv.candidate.quickforms.controller',
    'jv.onboarding.controller',
    'jv.apply-form-preview.service',
    'jv.candidate.details.summary.controller',
    'jv.candidate.details.paginated.controller',
    'jv.candidate.send.video.modal.controller',
    'jv.candidate.send.video.invite.modal.controller',
    'jv.candidate.eval.req.info.controller',
    'jv.candidate.eval.send.reminder.modal.controller',
    'jv.candidate.invite.reviewers.video.modal.controller',
    'jv.shareApplication.controller',
    'jv.candidates.search.controller',
    'jv.Common.Directives.SortList',
    'jv.Common.Directives.Tooltip',
    'jv.Common.Directives.Calendar',
    'jv.Common.Directives.Datepicker',
    'jv.Common.Directives.Select2',
    'jv.Common.MeetingRoomSelect',
    'jv.Common.Jobvite.Urls',
    'jv.Common.Directives.jvTinymce',
    'jv.Common.EmployeeSelect',
    'jv.Common.Directives.Reset',
    'jv.applicantGrid.controller',
    'jv.addToReq.controller',
    'jv.deleteCandidate.controller',
    'jv.moveAcrossWorkflow.controller',
    'jv.addToCollection.controller',
    'jv.sendMessage.controller',
    'jv.bulkSelfSchedule.controller',
    'jv.sendSMSMessage.controller',
    'jv.submitToHM.controller',
    'jv.offerReject.controller',
    'jv.moveCandidate.controller',
    'jv.changeStatus.controller',
    'jv.sendNote.controller',
    'jv.rejectCandidate.controller',
    'jv.bulkResumeDownload.controller',
    'jv.Common.TemplateLoader',
    'jv.Common.Modal',
    'jv.application.chevron.directive',
    'jv.Common.keyboardEvents.directive',
    'jv.candidate.modal.controller',
    'jv.search.save-modal.directive',
    'jv.search.save-list-modal.directive',
    'jv.Common.Directives.inputDropDown',
    'jv.Common.Directives.Formtemplate',
    'jv.Common.Directives.MessageTemplate',
    'jv.Common.MessageBar',
    'jv.Common.Loading',
    'videoQuickView',
    'jv.Common.Directives.fallbackImage',
    'jv.candidate.action.validation.directive',
    /*bulk actions*/
    /*bulk actions*/

    'jv.Candidate.Notes.Factory',
    'jv.Candidate.Tasks.Factory',
    'jv.Candidate.ManageCollabTeam.Controller',
    'jv.candidate.details.filters',
    'jv.candidate.details.intelligent.messaging.controller',
    'jv.candidate.details.crm.controller',
    'jv.candidate.details.workflow.interview.scheduler.controller',
    'jv.candidate.details.workflow.scheduler.messager.controller',
    //jhire modules
    'jv.candidate.details.workflow.scheduler.controller',
    'jv.candidate.details.evaluations.view.controller',
    'jv.candidate.details.evaluations.submit.controller',
    'jv.candidate.details.workflow.preInterviewForm.controller',
    'jv.candidate.details.workflow.reject.controller',
    'jv.candidate.details.workflow.offerLetter.controller',
    'jv.candidate.details.workflow.offerLetter.generation.controller',
    'jv.candidate.details.workflow.offerLetter.send.controller',
    'jv.candidate.details.workflow.offerLetter.upload.controller',
    'jv.eSig.OfferLetter.controller',
    'jv.candidate.details.workflow.messager.controller',
    'jv.cand.details.rank.directive',
    'jv.cand.details.talent.fit.directive',
    'jv.Common.Directives.jvSelect2ModalDropdown',
    'jv.auditlog.directive',
    'jv.common.pagination.directive',
    'jv.common.responsive',
    'jv.App.DocuSignAuth.Svc',
    'jv.Common.DataConsent',
    'jv.Common.Directives.Draggable.Tabs',
    'jv.common.numberFormatter.directive',
    'jv.common.currency.directive',
    'jv.Common.Directives.HideOnBlur',
    'jv.common.currency.applyfield.directive',
    'jv.Admin.CustomFormField.directive',
    //Common modules
    'jv.Videos.App'
])
.provider('routeFactory', function routeFactoryProvider(){
    const evalDetailTemplate = window.isAIInterviewIntelligenceEnabled ? 'details/evaluationsItxSummary.html' : 'details/evaluations.html';
    const evaViewlDetailTemplate = window.isAIInterviewIntelligenceEnabled ? 'details/evaluations/viewItxSummary.html' : 'details/evaluations/view.html';
    let notesTmpl = {
        templateUrl: 'details/notes.html',
        controller: 'jvCandDetailsNotesController'
    },
    messagesTmpl = {
        templateUrl: 'details/messages.html',
        controller: 'jvCandDetailsMessagesController'
    },
    applicationTmpl = {
        templateUrl: 'details/application.html',
        controller: 'jvCandDetailsResumeController'
    },
    evalTmpl = {
        templateUrl: evalDetailTemplate,
        controller: 'CandEval'
    },
    summaryTmpl = {
        templateUrl: 'details/summary.html',
        controller: 'jvCandidateDetailsSummaryController'
    },
    intelligentMessagingTmpl = {
        templateUrl: 'details/intelligentMessaging.html',
        controller: 'jvIntelligentMessagingController'
    },
    crmTmpl = {
        templateUrl: 'details/crm.html',
        controller: 'jvCRMController'
    },
    workflowTmpl = {
        templateUrl: 'details/workflow.html',
        controller: 'jvCandidateDetailsWorkflowBaseController'
    },
    activityTmpl = {
        templateUrl: 'details/activity.html',
        controller: 'jvCandDetailsActivityController'
    },
    feedTmpl = {
        templateUrl: 'details/feed.html'
    },
    evalDetailTmpl = {
        templateUrl: evaViewlDetailTemplate,
        controller: 'CandEvalDetails'
    },
    evalSubmitTmpl = {
        templateUrl: 'details/evaluations/submitEvaluation.html',
        controller: 'CandEvaluationSubmit'
    },
    schedulerTmpl = {
        templateUrl: 'details/workflow/scheduler.html',
        controller: 'jvCandidateDetailsWorkflowSchedulerController'
    },
    interviewSchedulerTmpl = {
        templateUrl: 'details/workflow/interviewScheduler.html'
    },
    interviewMessagerTmpl = {
        templateUrl: 'details/workflow/interviewMessager.html'
    },
    messagerTmpl = {
        templateUrl: 'details/workflow/messager.html',
        controller: 'jvCandidateDetailsWorkflowMessagerController'
    },
    rejectTmpl = {
        templateUrl: 'details/workflow/reject.html',
        controller: 'jvCandidateDetailsWorkflowRejectController'
    },
    offerTmpl = {
        templateUrl: 'details/workflow/offerForm.html',
        controller: 'jvCandidateDetailsWorkflowOfferLetterController'
    },
    offerGenerationTmpl = {
        templateUrl: 'details/workflow/generateOfferLetter.html',
        controller: 'jvCandidateDetailsWorkflowOfferLetterGenerationController'
    },
    offerSendTmpl = {
        templateUrl: 'details/workflow/sendOfferLetter.html',
        controller: 'jvCandidateDetailsWorkflowOfferLetterSendController'
    },
    offerUploadTmpl = {
        templateUrl: 'details/workflow/uploadOfferLetter.html',
        controller: 'jvCandidateDetailsWorkflowOfferLetterUpload'
    },
    offerEsigUploadTmpl = {
        templateUrl: 'details/workflow/UploadEsigOfferLetter.html'
    },
    offerApproverTmpl = {
        templateUrl: 'details/workflow/approversForOffer.html',
        controller: 'jvCandidateDetailsWorkflowOfferLetterController'
    },
    preInterviewCandTmpl = {
        templateUrl: 'details/application/preInterviewForm.html',
        controller: 'jvCandidateDetailsWorkflowPreInterviewFormController'
    },
    cancelTmpl = {
        templateUrl: 'details/workflow/cancel.html',
        controller: 'jvCandidateDetailsWorkflowMessagerController'
    },
    tasksTmpl = {
        templateUrl: 'details/tasks.html',
        controller: 'jvCandDetailsTaskController'
    },
    videoListTmpl = {
        templateUrl: '/video/video/recruiter/listviewTpl.html',
        controller: 'VideoListCtrl'
    },
    videoDetailsTmpl = {
        templateUrl: '/video/video/recruiter/detailsTpl.html',
        controller: 'VideoDetailsCtrl'
    },
    videoEvalsTmpl = {
        templateUrl: '/video/video/recruiter/evaluationGridTpl.html',
        controller: 'VideoEvalsCtrl'
    };
    var routes = {
        '/notes/:applicationId': notesTmpl,
        '/notes/:applicationId/:index': notesTmpl,
        '/notes/:applicationId/:index/:count': notesTmpl,
        '/messages/:applicationId': messagesTmpl,
        '/messages/:applicationId/:index': messagesTmpl,
        '/messages/:applicationId/:index/:count': messagesTmpl,
        '/application/:applicationId': applicationTmpl,
        '/application/:applicationId/:index': applicationTmpl,
        '/application/:applicationId/:index/:count': applicationTmpl,
        '/summary/:applicationId': summaryTmpl,
        '/summary/:applicationId/edit': summaryTmpl,
        '/summary/:applicationId/:index': summaryTmpl,
        '/summary/:applicationId/:index/:count': summaryTmpl,
        '/intelligentMessaging/:applicationId': intelligentMessagingTmpl,
        '/crm/:applicationId': crmTmpl,
        '/activity/:applicationId': activityTmpl,
        '/activity/:applicationId/:index': activityTmpl,
        '/activity/:applicationId/:index/:count': activityTmpl,
        '/feed/:applicationId': feedTmpl,
        '/tasks/:applicationId': tasksTmpl,
        '/workflow/:applicationId': workflowTmpl,
        '/workflow/:applicationId/:index?': workflowTmpl,
        '/workflow/:applicationId/:index?/:count?': workflowTmpl,
        '/workflow/:applicationId/:index?/:count?/:stateEId?': workflowTmpl,
        '/scheduler/:applicationId/:stateId': interviewSchedulerTmpl,
        '/scheduler/request/:applicationId/:stateId': interviewMessagerTmpl,
        '/scheduler/notify/:applicationId/:stateId': interviewMessagerTmpl,
        '/workflow-scheduler/:applicationId/:stateId': schedulerTmpl,
        '/workflow-scheduler/:applicationId/:stateId/:groupId': schedulerTmpl,
        '/workflow-scheduler/:applicationId': schedulerTmpl,
        '/workflow-scheduler/:applicationId/:stateId/mode/:mode': schedulerTmpl,
        '/workflow-messager/:applicationId/:stateId': messagerTmpl,
        '/workflow-messager/:applicationId/:stateId/:groupId': messagerTmpl,
        '/workflow-reject/:applicationId': rejectTmpl,
        '/workflow-cancel/:applicationId/:stateId/:groupId': cancelTmpl,
        '/workflow-offerLetter/:applicationId/:stateId': offerTmpl,
        '/workflow-offerLetter/:applicationId/:stateId/:mId': offerTmpl,
        '/workflow-offerApprovers/:applicationId/:stateId': offerApproverTmpl,
        '/workflow-offerApprovers/:applicationId/:stateId/:mId': offerApproverTmpl,
        '/workflow-generateOfferLetter/:applicationId': offerGenerationTmpl,
        '/workflow-generateOfferLetter/:applicationId/:stateId': offerGenerationTmpl,
        '/workflow-sendOfferLetter/:applicationId/:stateId': offerSendTmpl,
        '/workflow-uploadOfferLetter/:applicationId': offerUploadTmpl,
        '/workflow-uploadEsigOfferLetter/:applicationId': offerEsigUploadTmpl,
        '/evaluations/:applicationId': evalTmpl,
        '/evaluations/:applicationId/:view/:stateId': evalDetailTmpl,
        '/evaluations/:applicationId/:view/:stateId/:interviewId': evalDetailTmpl,
        '/workflow-evaluations/:applicationId/:stateId': evalTmpl,
        '/evaluations-submit/:applicationId/:stateId/:interviewId': evalSubmitTmpl,
        '/evaluations-submit/:applicationId/:stateId': evalSubmitTmpl,
        '/evaluations-edit/:applicationId/:stateId/:interviewId': evalSubmitTmpl,
        '/workflow-preInterviewForm/:applicationId/:stateId': preInterviewCandTmpl,
        '/profile/:applicationId': {}
    };
    if(window.properties.videoEnabled === 'true'){
        angular.extend(routes, {
            '/videos/:applicationId': videoListTmpl,
            '/videos/:applicationId/:interviewId': videoDetailsTmpl,
            '/videos/evals/:applicationId/:interviewId': videoEvalsTmpl,
            '/videos/evals/:applicationId/:interviewId/:displayType': videoEvalsTmpl
        });
    }
    return {
        routes: routes,
        $get: function(){
            return routes;
        }
    };
}).run(['$route', '$rootScope', '$location', function ($route, $rootScope, $location) {
    var original = $location.path;
    $location.path = function (path, reload) {
        if (reload === false) {
            var lastRoute = $route.current;
            var un = $rootScope.$on('$locationChangeSuccess', function () {
                $location.skipReload($route);
                $route.old = {
                    params: $route.current.params
                };
                $route.current = lastRoute;
                $rootScope.flags.loading = false;
                un();
            });
        }
        return original.apply($location, [path]);
    };
}])
.factory('routeDependencyUrls', [function(){
    return function(data){
        return {
            applicationPreferences: '/jhire/modules/candidates/paginate.html?{0}'.format($.param(data)),
            videoPermissions: '/video/action/application/{0}/views?traditional=true&{1}'.format(data.applicationId, $.param(data)),
            applicationDetails: '/jhire/action/application/{0}/details?{1}'.format(data.applicationId, $.param(data))
        };
    };
}])
.service('routeResolverService', ['$window','TemplateLoader','$q','$http','routeDependencyUrls','$log',
    function($window, TemplateLoader, $q, $http,routeDependencyUrls,$log){
        var routes = [], applicationId, data;
        function getBaseRoute(baseRoute){
            return routes['/{0}/:applicationId'.format(baseRoute)];
        }
        //check if application is alrady loaded
        function applicationIsLoaded(){
            return $window.__applicationDetails.details && $window.__applicationDetails.details.application.EId === applicationId;
        }
        //find user defined/default application tab
        function getLandingApplicationTab(config, route){
            if(route.url === '/profile/:applicationId'){
                if(config.candidateTabs && angular.isArray(config.candidateTabs) && config.candidateTabs.length){
                    var tab = config.candidateTabs[0].tabType;
                    var routeObject = getBaseRoute(tab);
                    if(angular.isDefined(routeObject)){
                        return {
                            url: '{0}/:applicationId'.format(tab),
                            controller: routeObject.controller,
                            templateUrl: routeObject.templateUrl
                        };
                    }else{
                        //remove the tab from candidate tabs array to avoid pagination issue
                        config.candidateTabs.splice(0,1);
                    }
                }
                var defaultSummaryTab = getBaseRoute('summary');
                return {
                    url: 'summary/:applicationId',
                    controller: defaultSummaryTab.controller,
                    templateUrl: defaultSummaryTab.templateUrl
                };
            }
            return route;
        }
        //get video permissions
        function getVideoPermissions(videoData){
            return eval('({' + videoData.videoViews + '})');
        }

        //get application permissions, user defined tab and video permissions
        function getApplicationDependencies(){
            var promiseQueue = [], urls = routeDependencyUrls(data);
            promiseQueue.push(TemplateLoader.inject(urls.applicationPreferences));
            promiseQueue.push($http.get(urls.applicationDetails));
            if($window.properties.videoEnabled === 'true'){
                promiseQueue.push(TemplateLoader.inject(urls.videoPermissions, 'videoViews'));
            }
            return promiseQueue;
        }

        //register partial views like summary, applications, feed etc. Fetch new/cached template to update tab view
        function getApplicationTabContentOnLoad(config, callback){
            var route = config && config.route;
            TemplateLoader.register(route.url, route.templateUrl);
            var tabContentLoaded = TemplateLoader.load(route.url, route.controller);
            if(angular.isDefined(tabContentLoaded)){
                tabContentLoaded.then(function(){
                    angular.extend(window.__applicationDetails, config);
                    callback(config);
                });
            }else{
                $log.warn('something went wrong while loading details tab! {0}'.format(JSON.stringify(route)));
            }
        }
        //gets application tab content without reloading parent dependencies
        function getApplicationContentOnSwitchingTab(route, callback){
            $window.__applicationDetails.route = route;
            getApplicationTabContentOnLoad(window.__applicationDetails, callback);
        }

        //defines complete flow of application details page loading
        this.load = function(currentRoute, onPageLoad, onTabLoad){
            if(!applicationIsLoaded()){
                $q.all(getApplicationDependencies()).then(function(allData){
                    if(angular.isDefined(allData) && angular.isArray(allData) && angular.isUndefined(allData[0].error)){
                        var config = {
                            views: angular.extend({}, allData[0].views, allData.length === 3 ? getVideoPermissions(allData[2]) : {}),
                            details: allData[1].data,
                            route: getLandingApplicationTab(allData[0], currentRoute)
                        };
                        if(angular.isDefined(allData[0].candidateTabs)){
                            config.candidateTabs = allData[0].candidateTabs;
                        }
                        getApplicationTabContentOnLoad(config, onPageLoad);
                    } else{
                        window.location.href= allData[0].error;
                    }
                });
            }else{
                getApplicationContentOnSwitchingTab(currentRoute, onTabLoad);
            }
        };
        this.register = function(urlRoutes, _data){
            routes = urlRoutes;
            applicationId = _data.applicationId;
            data = _data;
            return this;
        };
    }
])
.config(['$routeProvider','$locationProvider','routeFactoryProvider', '$provide', function($routeProvider, $locationProvider, routeFactoryProvider, $provide) {
    var searchTemplate = {
        controller: 'jvCandidatesSearchController',
        templateUrl: 'candidates/searchGrid.html',
        resolve: {
            resetCandidate: function($window, $q){
                var deferred = $q.defer();
                $window.__applicationDetails = {};
                $window.document.title = '{0} - {1}'.format($window.i18n.JOBVITE, $window.i18n.APPLICATIONS);
                if(!$window.properties.isCandidateSearchAccessible){
                    $window.location.href = '/admin/info/noprivileges.html';
                } else{
                    deferred.resolve();
                }
                return deferred.promise;
            }
        }
    };
    $routeProvider.when('/q/:query', searchTemplate);
    $routeProvider.when('/', searchTemplate);
    $locationProvider.hashPrefix('');
    $provide.decorator('$location', [
        '$delegate',
        '$rootScope',
        '$q',
        '$routeParams',
        'routeResolverService',
    function($delegate, $rootScope, $q, $routeParams, routeResolverService) {
        $delegate.skipReload = function(routeData) {
          angular.forEach(routeFactoryProvider.routes, function(routeTemplate, routeUrl) {
            if (routeData.current.$$route.originalPath === routeUrl) {
              setBrowserTitle();
              setApplicationDetails(routeTemplate, routeData, routeUrl, $rootScope, $q, $routeParams, routeResolverService);
            }
          });
        };
        return $delegate;
      }
]);

      function setApplicationDetails(routeTemplate,routeData,routeUrl,$rootScope, $q, $routeParams, routeResolverService){
        var deferred = $q.defer();
        var data = {
            applicationId: routeData.current.params.applicationId,
            readMode: (function(){
              return $rootScope.params && $rootScope.params.readMode ==='0' ? 0 : 1;
          }())
          }, currentRoute = angular.extend({}, routeTemplate, {
            url: routeUrl
          });
        if (angular.isDefined($routeParams.magicNumber)) {
          angular.extend(data, { magicNumber: $routeParams.magicNumber });
        }
        routeResolverService
          .register(routeFactoryProvider.routes, data)
          .load(currentRoute, deferred.resolve, function(config) {
            //refresh $routeParams while switching tabs
            if (routeData.old && routeData.old.params) {
              angular.extend($routeParams, routeData.old.params);
            }
            //broadcast to controller that template is fetched and ready to be displayed
            $rootScope.$broadcast('switching_application_tab');
            deferred.resolve(config);
          });
        return deferred.promise;
      }

      function setBrowserTitle(){
        window.document.title = '{0} - {1}'.format(
            window.i18n.JOBVITE,
            window.i18n.CANDIDATES_DETAILS_TITLE
          );
      }

    //building dependency resolution for candidate details routes
    //if candidate single page application is enabled
    angular.forEach(routeFactoryProvider.routes, function(routeTemplate, routeUrl){
        $routeProvider.when(routeUrl, {
            templateUrl: 'candidates/detailsView.html',
            controller: 'jvCandidatePaginatedDetailsController',
            resolve: {
                setTitle: function($window){
                    $window.document.title = '{0} - {1}'.format($window.i18n.JOBVITE, $window.i18n.CANDIDATES_DETAILS_TITLE);
                },
                currentApplicationDetails: function($rootScope, $route, $q, $routeParams, routeResolverService){
                    var deferred = $q.defer(), data = {
                        applicationId: $route.current.params.applicationId,
                        readMode: (function(){
                            return $rootScope.params && $rootScope.params.readMode ==='0' ? 0 : 1;
                        }())
                    }, currentRoute = angular.extend({}, routeTemplate, {
                        url: routeUrl
                    });
                    if(angular.isDefined($routeParams.magicNumber)){
                        angular.extend(data, {magicNumber : $routeParams.magicNumber});
                    }
                    routeResolverService.register(routeFactoryProvider.routes, data)
                        .load(currentRoute, deferred.resolve, function(config){
                            //refresh $routeParams while switching tabs
                            if($route.old && $route.old.params){
                                angular.extend($routeParams, $route.old.params);
                            }
                            //broadcast to controller that template is fetched and ready to be displayed
                            $rootScope.$broadcast('switching_application_tab');
                            deferred.resolve(config);
                        });
                    return deferred.promise;
                }
            }
        });
    });
}])
.value('modalTemplateUrl', '../../htm/common/modal.html')
.value('messageBarTemplateUrl', '../../htm/common/messageBar.html');